import './cheeus.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // 부트스트랩 CSS 임포트
import thumbnail from './smartmirrorimg/001.png';
import summary1 from './smartmirrorimg/002.png';
import summary2 from './smartmirrorimg/003.png';
import hardware from './smartmirrorimg/004.png';
import mainpage from './smartmirrorimg/005.png';
import touch1 from './smartmirrorimg/006.png';
import touch2 from './smartmirrorimg/007.png';
import register from './smartmirrorimg/008.png';
import database from './smartmirrorimg/009.png';
import powersaving from './smartmirrorimg/010.png';
import { Carousel } from 'react-bootstrap'; // react-bootstrap에서 Carousel 컴포넌트 가져오기

function Smartmirror() {
  const images = [thumbnail, summary1, summary2, hardware,
    mainpage, touch1, touch2, register, database, powersaving
  ];

  return (
    <div className="mydiary">
      <div className="mydiary-container">
        {/* 자동 슬라이드 비활성화 */}
        <Carousel interval={null} data-bs-theme="dark">
          {images.map((image, index) => (
            <Carousel.Item key={index}>
              <img className="d-block" src={image} alt={`Project ${index}`} />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
}

export default Smartmirror;
